import script from "./MicronutrientsView.vue?vue&type=script&setup=true&lang=js"
export * from "./MicronutrientsView.vue?vue&type=script&setup=true&lang=js"

import "./MicronutrientsView.vue?vue&type=style&index=0&id=62dff10a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62dff10a"]])

export default __exports__